{
  "de": {
    "startPage": {
      "collections": {
        "timedLabel": "Jetzt anmelden",
        "timedTitle": "Kostenfreier Adventskalender mit 24 Inspirationen"
      },
      "ctaBanner": {
        "aiDSGVOCompliant": {
          "checklist": {
            "1": "Schülerzugänge zu KI Chat, Rollen-Chatbot, PDF Chat, Bild generieren, Texteditor und KI Multimedia Tool",
            "2": "Keine Registrierung deiner Schüler*innen notwendig",
            "3": "Automatische Löschung nach 24 Stunden<br><a href=\"{href}\" target=\"_blank\">Mehr erfahren</a>"
          },
          "text": "Mit den fobizz Klassenräumen erhalten deine Schüler*innen ihren eigenen Zugang zur <b>fobizz KI-Assistenz</b> und können <b>DSGVO-konform</b> damit arbeiten.",
          "title": "Klassenräume: KI-Assistenz DSGVO-konform mit Schüler*innen nutzen"
        },
        "simpleAndSecure": {
          "checklist": {
            "1": "Einfach & sicher",
            "2": "DSGVO-konform",
            "3": "Innovativ: die neusten Tools, um den Unterricht noch besser und vielfältiger zu gestalten"
          },
          "subline": "Fobizz KI-Assistenz für noch schnellere Planung",
          "sublinePrefix": "Inkl. KI",
          "text": "Alle hilfreichen Tools für die Planung und Durchführung von Unterricht an einem Platz.",
          "title": "Digitalen Unterricht einfach und sicher gestalten"
        },
        "startFree": "Jetzt kostenfrei starten"
      },
      "headers": {
        "assistants": "Empfohlene KI-Assistenten",
        "assistantsBadge": "150+ Chatbots",
        "continueWorkshops": "Weitermachen",
        "pinnedTools": "Angepinnte Tools",
        "miniTools": "Beliebte Prompts",
        "miniToolsBadge": "55+ Prompts",
        "myAssistants": "Meine Assistenten",
        "newAssistants": "Neue Assistenten",
        "recommendationsForYou": "Empfehlungen für dich",
        "recommendedWorkshops": "Empfehlungen für dich",
        "savedCourses": "Gemerkte Kurse",
        "savedMaterial": "Gemerktes Material",
        "sectionChatTools": "KI Chat und Assistenten",
        "sectionFeedbackTools": "KI Feedback und Bewertung",
        "sectionMaterialTools": "Material anlegen",
        "sectionMaterials": "Unterrichtsmaterial nutzen",
        "sectionMultimediaTools": "KI Multimedia Tools",
        "sectionOnboarding": "Dein Einstieg in fobizz",
        "sectionShareTools": "Inhalte sicher teilen",
        "sectionWorkshops": "Weiterbildungen entdecken",
        "videoOnboarding": "fobizz in 100 Sekunden",
        "yourWorkshops": "Aktuelle Live-Webinare und Workshops"
      },
      "hiddenFeedbackTools": {
        "badge": "Wo sind die Tools?",
        "tooltip": "Diese Tools sind standardmäßig ausgeblendet und können auf Wunsch auf Schulebene freigeschaltet werden."
      },
      "howTo": {
        "bookmarkTeaserHeadline": "Kurse und Inhalte für später merken",
        "bookmarkTeaserLinkCourses": "Merkliste Fortbildungen",
        "bookmarkTeaserLinkMaterial": "Merkliste Material",
        "bookmarkTeaserText": "Merke dir Fortbildungen und Materialien mit Klick auf das Herz und finde sie einfach auf deiner Merkliste wieder.",
        "materialTeaserHeadline": "Sharing is caring: Material gemeinsam nutzen",
        "materialTeaserLink": "Tutorial ansehen",
        "materialTeaserText": "Alles Material steht unter CC-BY Lizenz. Per Remix kannst du es kostenfrei kopieren, für dich anpassen und weiter verwenden.",
        "materialTeaserTextCommunity": "Alles Material steht unter CC-BY Lizenz. Per Remix kannst du es kostenfrei kopieren und anpassen. Bitte prüfe vorher Inhalte und Links kritisch, auch hinsichtlich Urheberrecht und Datenschutz.",
        "materialTeaserVideoId": "1085940798",
        "materialTeaserVideoTitle": "Materialien anlegen und teilen"
      },
      "links": {
        "assistantsCatalog": "Alle Assistenten",
        "createClass": "Klassenraum anlegen",
        "hideOnboarding": "Einstieg in fobizz ausblenden",
        "miniToolsCatalog": "Weitere Ideen im Promptlabor",
        "toAssistantsCatalog": "Alle anzeigen",
        "toMaterials": "Alles anzeigen",
        "toMyAssistantsCatalog": "Alle anzeigen",
        "toSavedMaterials": "Deine Merkliste",
        "toSavedWorkshops": "Deine Merkliste",
        "toTools": "Alle Tools anzeigen",
        "toWorkshops": "Alle Fortbildungen",
        "watchTutorial": "Tutorial ansehen"
      },
      "onboarding": {
        "videoId": "1085940572",
        "videoTitle": "fobizz in 100 Sekunden"
      },
      "paragraphs": {
        "mySchoolClassesDisabled": "Die Klassenräume sind für deine Lizenzgruppe deaktiviert. Bitte wende dich für weitere Informationen an die Person, die die Lizenz verwaltet.",
        "onboarding": "Entdecke deine Möglichkeiten bei fobizz - kurz und knapp, als kompakte Einführung oder steige gleich mit deinem ersten Kurs ein.",
        "recommendationsAndProfile": "Diese Einstellungen werden auch für dein <a href=\"{href}\" target=\"_blank\">Profil</a> übernommen.",
        "recommendationsForYou": "Wir empfehlen dir Inhalte auf Basis deiner Profileinstellungen und deiner bereits belegten oder gemerkten Kurse oder Materialien."
      },
      "schoolClasses": {
        "videoId": "1085940985",
        "videoTitle": "fobizz Klassenräume in 30 Sekunden"
      },
      "toolTips": {
        "recommendationsForYou": "Hier kannst du festlegen, zu welchen Themen dir Empfehlungen angezeigt werden"
      },
      "tools": {
        "experimental": "Experimental",
        "headers": {
          "title": "Nutze hilfreiche Tools mit KI Unterstützung"
        },
        "pin": "„{name}“ anpinnen",
        "pinnedAnnouncement": "„{name}“ steht jetzt unter „Angepinnte Tools“.",
        "pinnedTeaser": "Hier werden deine Lieblings-Tools angezeigt, sobald du sie anpinnst. So kannst du schnell darauf zugreifen.",
        "unpinnedAnnouncement": "„{name}“ steht nicht mehr unter „Angepinnte Tools“."
      },
      "webinar": {
        "accessLinkLater": "Der Zugangslink erscheint später hier",
        "certificateLater": "Dein Zertifikat erscheint später hier",
        "enrolled": "Eingeschrieben",
        "participated": "Teilgenommen",
        "percentComplete": "{percent}% abgeschlossen",
        "reserveSpot": "Jetzt Platz sichern",
        "toCertificate": "Zum Zertifikat",
        "toLiveWebinar": "Zum Live-Webinar"
      }
    }
  }
}
